window.addEventListener('SITE_START', () => {
  // 윤리실천활동 카드 높이 맞춤
  const matchCardHeights = (selector = '.activity-card-list') => {
    const lists = document.querySelectorAll(selector);

    if (!lists.length) return;

    lists.forEach((list) => {
      const cards = list.querySelectorAll('.card');
      if (!cards.length) return;

      // 모바일 한 열일 때는 스킵
      if (window.innerWidth < 768) {
        cards.forEach((card) => (card.style.height = 'auto'));
        return;
      }

      // 초기화 후 다시 계산
      cards.forEach((card) => (card.style.height = 'auto'));
      const maxHeight = Math.max(...Array.from(cards).map((c) => c.offsetHeight));
      cards.forEach((c) => (c.style.height = `${maxHeight}px`));
    });
  };
  window.addEventListener('resize', () => {
    matchCardHeights();
  });
  matchCardHeights();

  // 제보센터 state 1 > 2 단계 이동
  const step1 = document.querySelector('.content-list[data-content-state="1"]');
  const step2 = document.querySelector('.content-list[data-content-state="2"]');
  const nextBtn = document.querySelector('[data-step="1to2"]');
  const tabList = document.querySelector('.tab-list');
  const header = document.querySelector('#header');

  if (!step1 || !step2 || !nextBtn || !tabList) return;

  nextBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    // 폼 데이터 가져오기
    const form = document.getElementById('reportForm');
    const fileInput = document.getElementById('upload1-input');
    if (!form) {
      console.error('reportForm을 찾을 수 없습니다.');
      return;
    }
    const isAnonymous = document.getElementById('agree-n').checked;
    const formData = new FormData(form);
    const inputName = form.querySelector('input[name="name"]');
    const inputPhone = form.querySelector('input[name="phone"]');

    // 익명/실명 제보에 따른 이메일 입력 요소 가져오기 함수
    function getEmailElements(form, isAnonymous) {
      const prefix = isAnonymous ? 'email-optional' : 'email';

      return {
        idInput: form.querySelector(`input[name="${prefix}-id"]`),
        directInput: form.querySelector(`input[name="${prefix}-direct"]`),
        domainValue: document.querySelector(`#${prefix}-domain-value`),
      };
    }

    const emailEls = getEmailElements(form, isAnonymous);
    const inputTitle = form.querySelector('input[name="title"]');
    const inputContent = form.querySelector('textarea[name="content"]');

    // 'reportType' 값 변환 및 가져오기
    formData.append('reportType', isAnonymous ? 'ANONYMOUS' : 'REAL_NAME');

    // --- 폼 유효성 검사 ---
    // (공통) 필수 동의 항목 검사 (check1, check2)
    if (!document.getElementById('check1').checked || !document.getElementById('check2').checked) {
      alert('필수 동의 항목을 체크해주세요.');
      scrollToTab(document.querySelector('[check-target="check1"]'));
      return;
    }

    // (실명제보) 작성자, 전화번호 검사
    if (!isAnonymous) {
      // '실명제보'일 경우
      if (!formData.get('name')) {
        alert('실명제보 시 작성자는 필수 입력 항목입니다.');
        inputName.focus();
        scrollToTab(document.querySelector('[check-target="name"]'));
        return;
      }
      if (!formData.get('phone')) {
        alert('실명제보 시 전화번호는 필수 입력 항목입니다.');
        inputPhone.focus();
        scrollToTab(document.querySelector('[check-target="phone"]'));
        return;
      }
    }
    else {
        //익명제보인 경우 작성자/전화번호 공백
        formData.set('name','');
        formData.set('phone','');
    }

    //(공통) 제목, 내용 검사
    if (!formData.get('title') || !formData.get('content')) {
      alert('제목과 내용은 필수 입력 항목입니다.');
      if (!formData.get('title')) {
        inputTitle.focus();
      } else {
        inputContent.focus();
      }
      scrollToTab(document.querySelector('[check-target="title"]'));
      return;
    }

    // (공통) 파일 크기 검사
    const files = fileInput.files;
    let totalSize = 0;
    const MAX_TOTAL_SIZE = 104857600;
    const MAX_FILE_SIZE = 52428800;

    if (files && files.length > 0) {
      for (const file of files) {
        totalSize += file.size; // totalSize 계산 추가
        // 개별 파일 크기 검사
        if (file.size > MAX_FILE_SIZE) {
          alert(`개별 파일의 최대 업로드 용량을 초과했습니다. (최대 50MB)`);
          return;
        }
      }

      // 총 파일 크기 검사
      if (totalSize > MAX_TOTAL_SIZE) {
        alert('한 번에 업로드할 수 있는 총 용량을 초과했습니다. (최대 100MB)');
        return;
      }
    }
    // --- 유효성 검사 끝 ---

    const id = emailEls.idInput.value.trim();
    const direct = emailEls.directInput.value.trim();
    const domainValue = emailEls.domainValue ? emailEls.domainValue.textContent.trim() : '선택';
    let emailFull;
    let domain;

    if (domainValue === '직접입력') {
      domain = direct;
    } else if (domainValue === '선택' || !domainValue) {
      // '선택'이거나 비어있으면
      domain = '';
    } else {
      domain = domainValue;
    }

    if (isAnonymous && id && !domain) {
      alert('이메일 도메인을 선택(또는 입력)해주세요.');
      emailEls.idInput.focus();
      // 익명 이메일 필드(check-target="email-optional")로 스크롤
      scrollToTab(document.querySelector('[check-target="email-optional"]'));
      return;
    }

    emailFull = id && domain ? `${id}@${domain}` : '';

    if (emailFull) {
      //DTO에서 받을 email
      formData.append('email', emailFull);
    }

    if (!isAnonymous && !emailFull) {
      alert('실명제보 시 이메일은 필수 입력 항목입니다.');

      emailEls.idInput.focus();
      scrollToTab(document.querySelector('[check-target="email"]'));
      return;
    }
      if (nextBtn.disabled) return;
      nextBtn.disabled = true;
      const originalBtnText = nextBtn.innerHTML;
    // --- try/catch 블록 시작 ---
    try {
      const response = await fetch('/api/ethics/reports', {
        method: 'POST',
        body: formData,
      });
      if (response.ok) {
        //성공 응답(JSON) 받기
        const result = await response.json();

        //Step 2에 데이터 채워넣기
        document.getElementById('resultName').textContent = isAnonymous ? '제보자' : result.reporterName;
        document.getElementById('resultReceiptNumber').textContent = result.receiptNumber;
        document.getElementById('resultAuthNumber').textContent = result.authenticationCode;
        document.getElementById('resultTitle').textContent = result.title;
        document.getElementById('resultContent').textContent = result.content;
        document.getElementById('resultCreatedAt').textContent = result.createDatePretty + ' 등록';

        //Step 전환 (AJAX 성공 시)
        step1.style.display = 'none';
        step2.style.display = '';

        //스크롤 이동
        scrollToTab(tabList);
      } else {
        // 실패 (HTTP 4xx, 5xx 상태 코드)
        let errorMsg = '제보 등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'; // 기본 오류 메시지
        try {
          // 서버가 보낸 JSON 오류 메시지 파싱 시도
          const errorData = await response.json(); // GlobalExceptionHandler가 보낸 JSON 파싱
          if (errorData && errorData.message) {
            errorMsg = errorData.message; // 서버의 구체적인 메시지 사용
          } else {
            errorMsg = `오류가 발생했습니다. (상태: ${response.status})`;
          }
        } catch (jsonError) {
          console.error('오류 응답 JSON 파싱 실패:', jsonError);
          errorMsg = `서버 응답 처리 중 오류가 발생했습니다. (상태: ${response.status})`;
        }
        alert(errorMsg); // 사용자에게 구체적인 또는 기본 오류 메시지 표시
      }
    } catch (error) {
      console.error('제보 등록 실패:', error);
      alert('제보 등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    } finally {
      //버튼 다시 활성화
        nextBtn.disabled = false;
        nextBtn.classList.remove('is-loading');
    }
  });

  // --- 처리결과 확인 (조회) 로직 ---

  // 1. 조회에 필요한 DOM 요소들 선택
  const searchBtn = document.querySelector('#searchReportBtn');
  const receiptNumberInput = document.querySelector('#report-number');
  const authCodeInput = document.querySelector('#auth-number');
  const searchFormContainer = searchBtn ? searchBtn.closest('.gray-border-box[data-anim-3]') : null;
  // 2. 결과 표시 영역 DOM 요소들 선택
  const resultArea = document.querySelector('#reportResultArea');
  const pendingBox = document.querySelector('#resultBoxPending');
  const completedBox = document.querySelector('#resultBoxCompleted');
  const completedReportBox = document.querySelector('#resultBoxCompletedReport');
  const completedAnswerBox = document.querySelector('#resultBoxCompletedAnswer');

  // 3. 조회 버튼 클릭 이벤트
  if (searchBtn) {
    searchBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      const receiptNumber = receiptNumberInput.value.trim();
      const authCode = authCodeInput.value.trim();

      // 3-1. 유효성 검사
      if (!receiptNumber) {
        alert('접수번호를 입력해주세요.');
        receiptNumberInput.focus();
        return;
      }
      if (!authCode) {
        alert('인증번호를 입력해주세요.');
        authCodeInput.focus();
        return;
      }

      // 3-2. 모든 결과 영역 우선 숨기기
      resultArea.style.display = 'none';
      pendingBox.style.display = 'none';
      completedBox.style.display = 'none';
      completedReportBox.style.display = 'none';
      completedAnswerBox.style.display = 'none';
      searchFormContainer.style.display = '';

      try {
        searchBtn.classList.add('is-loading'); // 로딩 시작

        // AJAX (fetch) 요청
        const response = await fetch(
          `/api/ethics/reports/search?receiptNumber=${encodeURIComponent(
            receiptNumber
          )}&authCode=${encodeURIComponent(authCode)}`
        );

        // 에러 처리 (404 Not Found)
        if (response.status === 404) {
          alert('제보 내역을 찾을 수 없습니다.\n접수번호와 인증번호를 다시 확인해주세요.');
          return;
        }
        if (!response.ok) {
          throw new Error(`서버 오류: ${response.status}`);
        }

        // 성공 (JSON 파싱)
        const result = await response.json(); // EthicsReportDTO

        // 제보자 이름 설정
        const reporterName = '제보자';

        // 공통 데이터(접수내역) 채우기
        document.getElementById('searchResultCreatedAt').textContent = result.createDatePretty + ' 등록';
        document.getElementById('searchResultTitle').textContent = result.title;
        document.getElementById('searchResultContent').textContent = result.content;

        // 상태(status)에 따라 다른 박스 보여주기
        if (result.status === 'PENDING') {
          // "처리중"일 때
          document.getElementById('searchResultNamePending').textContent = reporterName;
          document.getElementById(
            'searchResultReceiptPending'
          ).textContent = `제보하신 사건 (접수번호 ${result.receiptNumber})`;

          pendingBox.style.display = ''; // 처리중 박스 보이기
        } else {
          // "COMPLETED" 또는 기타 상태 (답변 완료)
          document.getElementById('searchResultNameCompleted').textContent = reporterName;
          document.getElementById(
            'searchResultReceiptCompleted'
          ).textContent = `제보하신 사건 (접수번호 ${result.receiptNumber})`;

          completedBox.style.display = '';
          completedReportBox.style.display = '';

          // 답변(answer) 데이터가 있을 경우
          if (result.answer) {
            document.getElementById('searchResultAnsweredAt').textContent =
              result.answer.createDatePretty + ' 등록';
            document.getElementById('searchResultAnswerTitle').textContent = result.answer.title;
            document.getElementById('searchResultAnswerContent').textContent = result.answer.content;

            completedAnswerBox.style.display = '';
          }
        }

        resultArea.style.display = '';
        searchFormContainer.style.display = 'none';
        animsInit('3');
      } catch (error) {
        console.error('제보 조회 실패:', error);
        alert('제보 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      } finally {
        searchBtn.classList.remove('is-loading'); // 로딩 끝
      }
    });
  }

  // --- 처리결과 확인 로직 끝 ---

  // 4. 처리결과 확인에서 이전 버튼 클릭 이벤트
  const prevBtn = document.querySelector('a[data-step="result"]');

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    // 모든 결과 영역 숨기고 조회로 돌아가기
    resultArea.style.display = 'none';
    pendingBox.style.display = 'none';
    completedBox.style.display = 'none';
    completedReportBox.style.display = 'none';
    completedAnswerBox.style.display = 'none';
    searchFormContainer.style.display = '';
  });

  // 제보센터/처리결과 확인 토글 탭
  const tabs = document.querySelectorAll('.left-tab-layout .__content .tab-list .__item');
  const contents = document.querySelectorAll('.content-wrapper');

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      // 활성 탭 변경
      tabs.forEach((t) => t.classList.remove('--active'));
      tab.classList.add('--active');

      // 일치하는 컨텐츠 노출
      const target = tab.dataset.tab;
      contents.forEach((c) => {
        c.style.display = c.dataset.content === target ? '' : 'none';
      });
      if (target === 'result' && searchFormContainer && resultArea) {
        // a. 조회 폼을 다시 보이게 함
        searchFormContainer.style.display = '';
        // b. 모든 결과 영역을 숨김
        resultArea.style.display = 'none';
        pendingBox.style.display = 'none';
        completedBox.style.display = 'none';
        completedReportBox.style.display = 'none';
        completedAnswerBox.style.display = 'none';
        // c. 입력 필드 초기화
        if (receiptNumberInput) receiptNumberInput.value = '';
        if (authCodeInput) authCodeInput.value = '';
        animsInit('3');
      } else if (target === 'report') {
        animsInit('2');
      } else {
        animsInit();
      }
    });
  });

  // 제보센터 - 내용 입력 - 익명 선택 시 항목 토글
  const radios = document.querySelectorAll('input[name="agree"]');
  const rows = document.querySelectorAll('[data-field]');
  const caution = document.querySelector('.form__row .form__caution'); // 주의사항

  // 익명일 때 보일 필드 / 실명일 때 보일 필드
  const showAnonymous = ['title', 'content', 'file', 'email-optional'];
  const showUser = ['name', 'phone', 'email', 'title', 'content', 'file'];

  if (!radios.length || !rows.length) return;

  const toggle = () => {
    const isAnonymous = document.querySelector('input[name="agree"]:checked')?.id === 'agree-n'; // 익명 여부
    const visible = isAnonymous ? showAnonymous : showUser;

    rows.forEach((r) => {
      const show = visible.includes(r.dataset.field);
      r.style.display = show ? '' : 'none';
      // 숨김 필드의 입력요소는 disabled 처리 (동일 name 충돌/검증 방지)
      // r.querySelectorAll('input, textarea').forEach(el => el.disabled = !show);
    });

    // 주의사항 표시: 익명일 때만
    if (caution) caution.style.display = isAnonymous ? '' : 'none';
  };

  radios.forEach((r) => r.addEventListener('change', toggle));
  requestAnimationFrame(toggle); // 초기 상태 반영

  // 스크롤 이동 함수
  const scrollToTab = (target) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (window.lenis) {
          // Lenis 사용 중
          window.lenis.scrollTo(target, {
            duration: 1.2,
            lock: true,
            offset: -80, // 고정 헤더 보정
            onComplete: () => {
              ScrollTrigger.refresh();
              header?.classList.add('--hide');
            },
          });
        } else {
          // Lenis 미사용 시 fallback (GSAP ScrollToPlugin)
          gsap.to(window, {
            scrollTo: target,
            duration: 1.2,
            ease: Quart.easeOut,
            onComplete: () => {
              ScrollTrigger.refresh();
              header?.classList.add('--hide');
            },
          });
        }
      });
    });
  };
});
